var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "left-arrow_1_",
    "data-name": "left-arrow (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 124.589,
    viewBox: "0 0 150 124.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3536",
    "data-name": "Group 3536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M8.432,92.206l-.234.051H108.57L77.017,60.634a8.287,8.287,0,0,1,0-11.65l4.91-4.912a8.213,8.213,0,0,1,11.593-.006l54.089,54.084a8.269,8.269,0,0,1,0,11.633L93.519,163.871a8.22,8.22,0,0,1-11.593,0l-4.91-4.912a8.125,8.125,0,0,1-2.393-5.8,7.881,7.881,0,0,1,2.393-5.687l31.91-31.8H8.319A8.5,8.5,0,0,1,0,107.263v-6.948A8.337,8.337,0,0,1,8.432,92.206Z",
    transform: "translate(0 -41.674)",
    fill: "#674188"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/Right-arrow.7f8e19ffff72f19f7c71d6bc967f9d61.svg";
export { ForwardRef as ReactComponent };